const baseUrl = '/billready';
export const billReadyRoutes = {
  /** When each bill on a Bills page was ready to collect (LB-6032). */
  forBills: "".concat(baseUrl, "/for-bills")
};